export const MAX_COUNT = 99;
export const MAX_DISPLAY_COUNT = '99+';
